import { combineReducers } from 'redux'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { eduCommissions } from '../../../api/eduCommissions'
import { START } from '../../../constants/action-postfix'
import { createActions } from '../../factory/actionFactory'
import { eduCommissionsListReducer } from './list/eduCommissionsListReducer'
import { eduCommissionsLoaderReducer } from './loader/eduCommissionsLoaderReducer'
import { currentReducer } from './current/currentReducer'

import {
  EDU_COMMISSIONS_LIST_REQUEST,
  EDU_COMMISSIONS_GET_REQUEST,
} from './eduCommissionsActionTypes'

export const eduCommissionsReducer = combineReducers({
  list:    eduCommissionsListReducer,
  loader:  eduCommissionsLoaderReducer,
  current: currentReducer,
})

// Actions
export const eduCommissionsListActions = createActions('eduCommissionsList', EDU_COMMISSIONS_LIST_REQUEST)
export const eduCommissionsGetActions  = createActions('eduCommissionsGet',  EDU_COMMISSIONS_GET_REQUEST)

// Watcher
export function* eduCommissionsWatcher() {
  yield all([
    takeLatest(`${EDU_COMMISSIONS_LIST_REQUEST}${START}`, eduCommissionsListWorker),
    takeLatest(`${EDU_COMMISSIONS_GET_REQUEST}${START}`,  eduCommissionsGetWorker),
  ])
}

// Workers
function* eduCommissionsListWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = { ...payload, ...auth }
    const response = yield call(eduCommissions.list, params)
    yield put(eduCommissionsListActions.eduCommissionsListRequestSuccess(response.data.Answer.Data || []))
  } catch (error) {
    yield put(eduCommissionsListActions.eduCommissionsListRequestError(error))
  }
}

function* eduCommissionsGetWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = { ...payload, ...auth }
    const response = yield call(eduCommissions.getById, params)
    const item = response.data.Answer.Data?.[0] || null
    yield put(eduCommissionsGetActions.eduCommissionsGetRequestSuccess(item))
  } catch (error) {
    yield put(eduCommissionsGetActions.eduCommissionsGetRequestError(error))
  }
}
